/* eslint-disable react/prop-types */
import React from 'react';
import { useFormikContext } from 'formik';

import BrandSearch from '@components/form/search/BrandSearch';
import SociollaErrorMessage from './SociollaErrorMessage';

function SociollaBrandSeach({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <BrandSearch
        onChange={async (value) => {
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={values[name]}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaBrandSeach;
